<template>
  <vs-popup
    class="custom-popup"
    :active.sync="showPopup"
    @close="closePopup"
    title=""
  >
    <vx-card>
      <div class="vx-card__title mb-6">
        <h2 class="mb-4">Добавление нового вебхука</h2>
        <p>Заполните поля ниже</p>
      </div>
      <div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-input
              class="w-full"
              label="Название"
              name="name"
              v-validate="'required'"
              v-model="settings.name"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-input
              class="w-full"
              label="URL"
              name="url"
              v-validate="{required: true, url: {require_protocol: true }}"
              v-model="settings.url"
            />
            <span class="text-danger text-sm" v-show="errors.has('url')">{{ errors.first('url') }}</span>
          </div>
        </div>
        <h4 class="mb-6">События</h4>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="settings.settings['triggers.new_message']"
            >Уведомлять о новом обращении
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="settings.settings['triggers.callback_request']"
            >Уведомлять о заказе обратного звонка
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="settings.settings['triggers.new_session']"
            >Уведомлять о новом сообщении клиентов
            </vs-checkbox>
          </div>
          <div class="vx-col w-full lg:w-1/2 mb-6">
            <vs-checkbox
              class="items-start"
              v-model="settings.settings['triggers.manual_dialog_switch']"
            >Уведомлять при переводе диалога на оператора
            </vs-checkbox>
          </div>
        </div>
        <vs-button @click.prevent="add">Добавить</vs-button>
      </div>
    </vx-card>
  </vs-popup>
</template>

<script>
import Webhook from '../../../api/http/models/webhook/Webhook'

export default {
  props: {
    companySlug: {
      type: String,
      required: true
    },
    channelSlug: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      showPopup: false,
      settings: {
        name: '',
        url: '',
        settings: {
          'triggers.new_message': false,
          'triggers.new_session': false,
          'triggers.callback_request': false,
          'triggers.manual_dialog_switch': false
        }
      }
    }
  },

  async created () {
    this.showPopup = true
  },

  methods: {
    async add () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const response = await Webhook.add(this.companySlug, this.channelSlug, {
          name: this.settings.name,
          url: this.settings.url,
          settings: {
            'triggers.new_message': this.settings.settings['triggers.new_message'],
            'triggers.new_session': this.settings.settings['triggers.new_session'],
            'triggers.callback_request': this.settings.settings['triggers.callback_request'],
            'triggers.manual_dialog_switch': this.settings.settings['triggers.manual_dialog_switch']
          }
        })

        if (response.status === 'success' && response.data) {
          this.$vs.notify({
            color: 'success',
            title: 'Вебхук успешно добавлен',
            text: ''
          })
        }

        this.$emit('added', response.data)
        this.closePopup()
      }
    },

    closePopup () {
      this.$emit('close')
    }
  }
}
</script>
